export default __webpack_public_path__ + "static/media/chess-img.f5e91dbe.webp";